import { render, staticRenderFns } from "./productModfiyPage.vue?vue&type=template&id=f5692f5c&scoped=true&"
import script from "./productModfiyPage.vue?vue&type=script&lang=js&"
export * from "./productModfiyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5692f5c",
  null
  
)

export default component.exports